var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sum"},[_c('div',{staticClass:"sum-txt"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('h3',[_vm._v(" "+_vm._s(_vm.value)+" ")])]),_c('span',{staticClass:"icon"},[_vm._t("icon")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }